// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    {
      "sub": "程序设计基础",
      "tec": "孙丽娜",
      "week": "6,8-18周",
      "add": "教学楼C座404管理"
    },
    {
      "sub": "高等数学（一）",
      "tec": "刘晓静",
      "week": "6,8-18周",
      "add": "教学楼A座326电力"
    },
    0,
    0,
    0
  ],
  "2": [
    {
      "sub": "数字媒体导论",
      "tec": "张文强",
      "week": "6,8-14周",
      "add": "实训楼F座307信机"
    },
    {
      "sub": "心理健康与调适",
      "tec": "王倩",
      "week": "8-17周",
      "add": "教学楼A座116电力"
    },
    [
      {
        "sub": "大学英语（一）",
        "tec": "曹艳春",
        "week": "6-17周",
        "add": "实训楼E座412语音室"
      },
      {
        "sub": "26计理2-2",
        "tec": "徐亮",
        "week": "6-17周",
        "add": "实训楼E座406语音室"
      },
      {
        "sub": "26计理1-1",
        "tec": "王国志",
        "week": "6-17周",
        "add": "实训楼E座302语音室"
      },
      {
        "sub": "26计理1-2",
        "tec": "刘娜",
        "week": "6-17周",
        "add": "实训楼E座310"
      }
    ],
    {
      "sub": "体育（一）",
      "tec": "樊绍斌",
      "week": "7-18周",
      "add": "（7-18周[07-08节]）"
    },
    0
  ],
  "3": [
    {
      "sub": "军事理论",
      "tec": "姚文亮",
      "week": "8-16周",
      "add": "教学楼B座424能动"
    },
    {
      "sub": "高等数学（一）",
      "tec": "刘晓静",
      "week": "6,8-18周",
      "add": "教学楼A座117电力"
    },
    0,
    [
      {
        "sub": "健康教育",
        "tec": "王紫璎",
        "week": "6-11周",
        "add": "教学楼C座210教务"
      },
      {
        "sub": "健康教育",
        "tec": "王紫璎",
        "week": "12周",
        "add": "教学楼C座210教务"
      },
      {
        "sub": "健康教育",
        "tec": "王紫璎",
        "week": "12周",
        "add": "教学楼C座210教务"
      },
      {
        "sub": "健康教育",
        "tec": "王紫璎",
        "week": "13周",
        "add": "教学楼C座210教务"
      },
      {
        "sub": "健康教育",
        "tec": "王紫璎",
        "week": "13周",
        "add": "教学楼C座210教务"
      },
      {
        "sub": "健康教育",
        "tec": "王紫璎",
        "week": "14周",
        "add": "教学楼C座210教务"
      },
      {
        "sub": "健康教育",
        "tec": "王紫璎",
        "week": "14周",
        "add": "教学楼C座210教务"
      },
      {
        "sub": "健康教育",
        "tec": "王紫璎",
        "week": "15周",
        "add": "教学楼C座210教务"
      },
      {
        "sub": "健康教育",
        "tec": "王紫璎",
        "week": "15周",
        "add": "教学楼C座210教务"
      },
      {
        "sub": "健康教育",
        "tec": "王紫璎",
        "week": "16周",
        "add": "教学楼C座210教务"
      },
      {
        "sub": "健康教育",
        "tec": "王紫璎",
        "week": "16周",
        "add": "教学楼C座210教务"
      },
      {
        "sub": "健康教育",
        "tec": "王紫璎",
        "week": "17周",
        "add": "教学楼C座210教务"
      },
      {
        "sub": "健康教育",
        "tec": "王紫璎",
        "week": "17周",
        "add": "教学楼C座210教务"
      }
    ],
    0
  ],
  "4": [
    [
      {
        "sub": "大学英语（一）",
        "tec": "刘娜",
        "week": "6-17周",
        "add": "教学楼D座226经管"
      },
      {
        "sub": "26计理2-1",
        "tec": "王国志",
        "week": "6-17周",
        "add": "教学楼A座126信息"
      },
      {
        "sub": "26计理1-2",
        "tec": "徐亮",
        "week": "6-17周",
        "add": "教学楼A座125信息"
      },
      {
        "sub": "26计理1-1",
        "tec": "曹艳春",
        "week": "6-17周",
        "add": "教学楼A座122信息"
      }
    ],
    {
      "sub": "程序设计基础",
      "tec": "孙丽娜",
      "week": "6,8-18周",
      "add": "教学楼C座304教务"
    },
    0,
    0,
    {
      "sub": "形势与政策",
      "tec": "王姝",
      "week": "6,8-10周",
      "add": "教学楼C座311教务"
    }
  ],
  "5": [
    {
      "sub": "数字媒体导论",
      "tec": "张文强",
      "week": "6,8-14周",
      "add": "实训楼F座307信机"
    },
    {
      "sub": "高等数学（一）",
      "tec": "刘晓静",
      "week": "6,8-18周",
      "add": "教学楼A座425机械"
    },
    {
      "sub": "就业创业指导",
      "tec": "朱雪枫",
      "week": "8-12周",
      "add": "实训楼F座402信息"
    },
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
